import { jobSelectors } from 'redux/_core/job';
import { IStore } from '../../store';
import {
	IORB1Store,
    TORB1HistoryFilters,
} from './@types';
import { EORB1Actions } from './actions';

const orb1Selectors = {
    _getStore(store: IStore) {
        return store.app.orb1;
    },
    getHistoryList(store: IORB1Store) {
        return store.records.ids.map((id) => ({
            ...store.records.byIds[id],
        }));
    },
    getFilter(store: IORB1Store): TORB1HistoryFilters {
        return {
            ...store.filter,
            shownRecords: store.filter.shownRecords
                ? store.filter.shownRecords
                : 'ALL',
        };
    },
	jobToLoadHistory(store: IORB1Store) {
		return jobSelectors.getJobStatus(store, EORB1Actions.HISTORY_LOAD);
	},
};
export default orb1Selectors;
